import { nativeApplicationVersion, nativeBuildVersion } from 'expo-application';
import * as Device from 'expo-device';
import { Platform } from 'react-native';

export function getUserAgent(): string {
  const mobileUserAgent = () => {
    return `${
      Device.osName
    }-${nativeApplicationVersion}-${nativeBuildVersion}-${'Open English'}`;
  };

  return Platform.OS === 'web' ? navigator.userAgent : mobileUserAgent();
}
